export default "__VITE_ASSET__D1Ts2MYw__"